import { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Body from './components/Body/Body';
import Connect from './components/Connect/Connect';
import { useLocalStorage } from './components/Context/LocalStorageContext';
import ErrorPage from './components/Error/ErrorPage';
import config from './config';

// Google Analytics
import ReactGA from 'react-ga4';
const TRACKING_ID = (config.ga_id); // your Measurement ID

function App() {

    // const [darkTheme, toggleTheme] = useTheme();
    const location = useLocation();

    const genRanHex = (size: number) => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

    // INIT USER SESSION
    const [sessionId, setSessionId] = useLocalStorage("sessionId");

    const getSessionId = () => {
        // CHECK IF ALREADY DEFINED
        if (!sessionId) {
            setSessionId(genRanHex(64));
        }
    }
    // use useEffect func to perform side effects, like initializing starting state of component vars.
    useEffect(getSessionId)

    useEffect(() => {
        ReactGA.initialize(TRACKING_ID);
        // Send pageview with a custom path
        ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Page" });
    }, [])


    return (
        <div className={/*(darkTheme ? "dark " :" ")*/ "" + (location.pathname.includes("/connect") ? " bg-primary-50 bg-opacity-90 xsm:bg-opacity-100 " : " bg-white ") + `  flex min-h-screen flex-col items-center font-sans dark:bg-gray-900`}>
            <Header sessionId={sessionId ?? ""} />

            <main className="max-xl:w-full z-0 grow ">
                <div className="flex xl:w-[1280px] w-full max-w-screen-xl gap-0 sm:gap-12 px-8 sm:px-12 py-4 sm:py-12">

                {/*<main className="z-0 grow ">
                <div className="relative flex w-[1280px] max-w-screen-xl gap-10 flex-col px-12 py-12">*/}

                    <Routes>
                        {/* Define specific routes */}
                        <Route path="/idt/v2/" element={<Body sessionId={sessionId} />} />
                        <Route path="/idt/v2/error" element={<ErrorPage />} />
                        <Route path="/idt/v2/connect" element={<Connect sessionId={sessionId ?? ""} />} />

                        {/* Redirect /idt and /idt/ to /idt/v2/ */}
                        <Route path="/idt" element={<Navigate to="/idt/v2/" replace />} />
                        <Route path="/idt/" element={<Navigate to="/idt/v2/" replace />} />

                        {/* Redirect /idt/v2 to /idt/v2/ */}
                        <Route path="/idt/v2" element={<Navigate to="/idt/v2/" replace />} />

                        {/* Redirect / to /idt/v2/ */}
                        <Route path="/" element={<Navigate to="/idt/v2/" replace />} />

                        {/* Catch-all route */}
                        <Route path="*" element={<Navigate to="/idt/v2/" replace />} />
                    </Routes>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default App;
